module.exports = __webpack_public_path__ + "img/CIT-logo.67b880a7.png";